<template>
  <span
    class="icon-svg"
    :style="{ fontSize: size + 'px', color: color }"
    :aria-label="icon"
    role="img"
    v-on="$listeners">
    <svg
      class="icon"
      aria-hidden="true">
      <use :xlink:href="icon"></use>
    </svg>
    <slot></slot>
  </span>
</template>
<script>
export default {
  name: 'IconSvg',
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: Number
    },
    color: {
      type: String
    }
  }
}
</script>

<style lang="less" scoped>
.icon-svg {
  display: inline-block;
  line-height: 0;
  // text-align: center;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  cursor: pointer;
}
</style>
